<template>
	<div class="page">
		<!-- your page -->
		<div class="address">
			<div class="title">
				地址列表
			</div>
			<div class="new">
				<button @click="newAddress">
					+添加新地址
				</button>
			</div>
			<div class="table">
				<div class="thead">
					<div class="td name">收货人</div>
					<div class="td detail">详细地址</div>
					<div class="td phone">手机号</div>
					<div class="td operation">操作</div>
				</div>
				<div v-for="item in list" class="tableLine">
					<div class="td name">{{item.name}}</div>
					<div class="td detail">{{item.address}}</div>
					<div class="td phone">{{item.phone}}</div>
					<div class="td operation">
						<button :data-id="item.id" @click="change">修改</button>
						<button :data-id="item.id" @click="del">删除</button>
						<button class="default" :data-id="item.id" v-show="item.default">当前默认</button>
						<button :data-id="item.id" v-show="!item.default" @click="setDefault">设为默认</button>
					</div>
				</div>
			</div>
			<div class="newFormArea" v-if="newFormShow">
				<div class="newFormBox">
					<div class="newFormTitle">
						新增收货地址
						<img src="../../assets/index/close.png" alt="" @click="closeForm">
					</div>
					<div class="newForm">
						<div class="line">
							<div class="lineTitle">收货人姓名:</div>
							<div class="inputBox">
								<input type="text" placeholder="请输入收货人的姓名" v-model="name">
							</div>
						</div>
						<div class="line">
							<div class="lineTitle">电子邮箱:</div>
							<div class="inputBox">
								<input type="email" placeholder="请输入邮箱" v-model="email">
							</div>
						</div>
						<div class="line">
							<div class="lineTitle">手机号码:</div>
							<div class="inputBox">
								<input type="number" placeholder="请输入手机号" v-model="phone">
							</div>
						</div>
						<div class="line">
							<div class="lineTitle">地区选择:</div>
							<div class="inputBox">
								<select name="" id="" v-model="province" @change="changeP">
									<option v-for="item in provinceList" :value="item.id">{{item.name}}</option>
								</select>
								<select name="" id="" v-model="city" @change="changeC">
									<option v-for="item in cityList" :value="item.id">{{item.name}}</option>
								</select>
								<select name="" id="" v-model="area">
									<option v-for="item in areaList" :value="item.id">{{item.name}}</option>
								</select>
							</div>
						</div>
						<div class="line">
							<div class="lineTitle">详细地址:</div>
							<div class="inputBox">
								<input type="text" placeholder="请输入详细的街道地址门牌号" v-model="detail">
							</div>
						</div>
						<div class="line">
							<div class="lineTitle"></div>
							<div class="inputBox">
								<div class="defaultRadio">
									<div class="defaultIn" @click="addDefault">
										<img src="../../assets/person/select.png" alt="" v-show="defaultShow">
									</div>
								</div>
								<div class="defaultWord">
									设为默认
								</div>
							</div>
						</div>
						<div class="line">
							<div class="save" @click="saveAddress">
								保存
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'addressList',
		data(){
			return {
				list:[],
				newFormShow:false,
				name:'',
				email:0,
				phone:'',
				province:'',
				city:'',
				area:'',
				provinceList:[],
				cityList:[],
				areaList:[],
				detail:'',
				defaultShow:false
			}
		},
		methods:{
			saveAddress(){
				var that = this
				var def = function(){
					var defaultShow = that.defaultShow
					if(defaultShow){
						return 1
					}else{
						return 2
					}
				}
				if(this.name==""){
					this.globalTest('user.vuesaveusership','error','请输入名称',res.data)
				}
				if(this.phone<=0&&(this.phone+'').length!=11){
					this.globalTest('user.vuesaveusership','error','请输入正确的手机号',res.data)
				}
				if(this.email==""){
					this.globalTest('user.vuesaveusership','error','请输入邮箱',res.data)
				}
				if(this.area==""){
					this.globalTest('user.vuesaveusership','error','请选择地区',res.data)
				}
				if(this.detail==""){
					this.globalTest('user.vuesaveusership','error','请输入详细地址',res.data)
				}
				var data = {
					name:this.name,
					mobile:this.phone,
					email:this.email,
					area_id:this.area,
					address:this.detail,
					is_def:def(),
					token:this.token,
					method:"user.vuesaveusership"
				}
				if(this.isChange){
					data['id'] = this.changeId
					data['method'] = "user.editship"
				}
				this.request(data,function(res){
					if(res.status){
						that.list = []
						that.newFormShow = false
						that.fetchData()
						that.globalTest('user.vuesaveusership','success','添加收货地址成功')
					}else{
						that.globalTest('user.vuesaveusership','error',res.msg,res.data)
					}
				})
			},
			addDefault(){
				if(this.defaultShow){
					this.defaultShow = false
				}else{
					this.defaultShow = true
				}
			},
			getProvince(){
				var data = {
					method:'user.area',
					id:''
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.provinceList = res.data
						that.province = res.data[0].id
						that.changeP()
					}else{
						that.globalTest('user.area','error',res.msg,res.data)
					}
				})
			},
			closeForm(){
				this.newFormShow = false
			},
			changeP(){
				var pid = this.province
				var data = {
					id:pid,
					method:"user.area"
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.cityList = res.data
						that.city = res.data[0].id
						that.changeC()
					}else{
						that.globalTest('user.area','error',res.msg,res.data)
					}
				})
			},
			changeC(){
				var cid = this.city
				var data = {
					id:cid,
					method:"user.area"
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.areaList = res.data
						that.area = res.data[0].id
					}else{
						that.globalTest('user.area','error',res.msg,res.data)
					}
				})
			},
			newAddress(){
				this.newFormShow=true
				this.name=""
				this.phone=""
				this.email=""
				this.area=""
				this.detail=""
				this.getProvince()
			},
			change(e){
				var id = e.target.dataset.id
				this.newFormShow=true
				var data = {
					id: id,
					token: this.token,
					method: "user.getshipdetail"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.name = res.data.name
						that.phone = res.data.mobile
						that.email = res.data.email
						that.detail = res.data.address
						that.changeId = res.data.id
						that.isChange = true
						that.getProvince()
					}else{
						that.globalTest('user.getshipdetail','error',res.msg,res.data)
					}
				})
			},
			del(e){
				var id = e.target.dataset.id
				var data = {
					id:id,
					token:this.token,
					method:"user.removeship"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.list=[]
						that.fetchData()
						that.globalTest('user.removeship','success','删除地址成功')
					}else{
						that.globalTest('user.removeship','error',res.msg,res.data)
					}
				})
			},
			setDefault(e){
				var id = e.target.dataset.id
				var data = {
					id:id,
					token:this.token,
					method:"user.setdefship"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.list=[]
						that.fetchData()
						that.globalTest('user.setdefship','success','默认地址修改成功')
					}else{
						that.globalTest('user.setdefship','error',res.msg,res.data)
					}
				})
			},
			fetchData(){
				var data ={
					token:this.token,
					method:"user.getusership"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var list = res.data
						for (var i = 0; i < list.length; i++) {
							var item = list[i]
							var def = function(){
								if(item.is_def==1){
									return true
								}else{
									return false
								}
							}
							var obj = {
								id:item.id,
								name:item.name,
								address:item.area_name+item.address,
								phone:item.mobile,
								default:def()
							}
							that.list.push(obj)
						}
					}else{
						that.globalTest('user.getusership','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.token = localStorage.getItem('token')
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.address{
		width: 100%;
		padding: 0px 10px;
		box-sizing: border-box;;
	}
	.title{
		width: 100%;
		height: 50px;
		line-height: 60px;
		border-bottom: 1px solid #C3C3C3
	}
	.new{
		width: 100%;
		height: 60px;
	}
	.new button{
		width: 100px;
		height: 40px;
		flex: left;
		margin-top: 10px;
		background: #036DEE;
		color: #FFFFFF;
		border: none;
		cursor: pointer;
	}
	.new button:hover{
		background: #FFFFFF;
		border:1px solid #036DEE;
		box-sizing: border-box;
		color: #036DEE;
	}
	.table{
		width: 100%;
		border: 1px solid #B3B3B3;
		box-sizing: border-box;
	}
	.thead{
		width: 100%;
		height: 40px;
		background: #e0edff;
		line-height: 40px;
		border-bottom: 1px solid #B3B3B3;
	}
	.tableLine{
		width: 100%;
		box-sizing: border-box;
		line-height: 24px;
		border-bottom: 1px solid #B3B3B3;
	}
	.tableLine:last-child{
		border-bottom: none;
	}
	.thead,.tableLine{
		font-size: 0px;
		letter-spacing: -6px;
	}
	.td{
		display: inline-block;
		vertical-align: top;
		letter-spacing: normal;
		text-align: center;
		border-right: 1px solid #B3B3B3;
		box-sizing: border-box;
	}
	.tableLine .td{
		padding: 12px 0px;
		box-sizing: border-box;
	}
	.td:nth-child(4){
		border-right: none;
	}
	.name{
		width: 149px;
	}
	.detail{
		width: 460px;
	}
	.phone{
		width: 150px;
	}
	.operation{
		width: 159px;
	}
	.operation button{
		background: none;
		border: none;
		padding: 0px 5px;
		box-sizing: border-box;
		font-size: 12px;
		cursor: pointer;
	}
	.operation button:hover{
		color: #036DEE;
	}
	.operation .default{
		color:red;
	}
	.newFormArea{
	    width: 100%;
	    height: 100%;
	    position: fixed;
	    background: rgba(0, 0, 0, 0.6);
	    left: 0px;
	    top: 0px;
		z-index: 12;
	}
	.newFormBox{
	    width: 500px;
	    height: 430px;
	    position: fixed;
	    left: 50%;
	    top: 50%;
	    margin-left: -250px;
	    margin-top: -215px;
	    background: #FFFFFF;
	}
	.newFormBox .newFormTitle{
	    width: 100%;
	    height: 50px;
		border-bottom:1px solid #036DEE;
	    color: #036DEE;
	    padding:0px 10px;
	    box-sizing: border-box;
	    line-height: 50px;
	    font-size: 18px;
	}
	.newFormTitle img{
	    width: 16px;
	    height: 16px;
	    float:right;
	    margin-top: 17px;
	    margin-right: 10px;
	}
	.newForm{
	    width: 100%;
	    height: 330px;
	    padding: 0px 10px;
	    box-sizing: border-box;
	}
	.newForm .line{
	    width: 100%;
	    height: 50px;
	    line-height: 50px;
	    position: relative;
	}
	.newForm .line .lineTitle{
	    width: 80px;
	    height: 100%;
	    position: absolute;
	    left: 0px;
	    top: 0px;
		display: flex;
		justify-content: flex-end;
		padding-right: 5px;
		box-sizing: border-box;
	}
	.newForm .line .inputBox{
	    width: 100%;
	    height: 100%;
	    padding-left: 80px;
	    padding-top: 10px;
	    box-sizing: border-box;
	}
	.newForm .line .inputBox input{
	    width: 200px;
	    height: 30px;
	    display: block;
	    border:1px solid #B3B3B3;
		padding-left: 5px;
		box-sizing: border-box;
	}
	.newForm .line .inputBox select{
	    width: 100px;
	    height: 30px;
	    float: left;
	    margin-left: 10px;
	}
	.newForm .line .inputBox select:nth-child(1){
	    margin-left:0px;
	}
	.defaultRadio{
	    width: 30px;
	    height: 100%;
	    float: left;
	}
	.defaultIn{
	    width: 20px;
	    height: 20px;
		border: 1px solid #D3D3D3;
	    box-sizing: border-box;
	    margin-top: 5px;
	}
	.defaultIn img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.defaultWord{
	    width: 100px;
	    height: 40px;
	    float: left;
	    line-height: 30px;
	}
	.save{
	    width: 150px;
	    height: 40px;
	    margin:0 auto;
	    background: #333333;
	    color: #FFFFFF;
	    text-align: center;
	    line-height: 40px;
	    margin-top: 10px;
	}
</style>
